module.exports = __webpack_public_path__ + "static/img/img2.67f3dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2.png
// module id = xx0f
// module chunks = 0